import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useNexusSync } from '../../../context/NexusSyncContext';

// Outils communs aux onglets de la fiche projet.

// Nexus a modifié quelque chose : onMutation(entity, action) si cela concerne ce projet. Même règle que l'ancienne
// fiche : sans project_id, seules les écritures MCP comptent. La modification déjà connue au montage de l'onglet est
// ignorée (l'onglet vient de charger ses données).
export const useNexusProjectRefresh = (projectId, onMutation) => {
  const { lastMutation } = useNexusSync();
  const seen = useRef(lastMutation);
  const callback = useRef(onMutation);
  callback.current = onMutation;

  useEffect(() => {
    const meta = lastMutation?.metadata;
    if (!meta || lastMutation === seen.current) return;
    seen.current = lastMutation;
    const raw = meta.project_id ?? meta.projectId;
    const target = raw == null ? null : Number(raw);
    if (target == null ? lastMutation.source !== 'mcp' : target !== Number(projectId)) return;
    callback.current(String(meta.entity || '').toLowerCase(), String(meta.action || '').toLowerCase());
  }, [lastMutation, projectId]);
};

// Erreur d'un onglet, affichée quelques secondes. attempt(label, action) l'affiche puis relance l'erreur, pour que le
// panneau appelant sache que l'action a échoué.
export const useTabError = () => {
  const [error, setError] = useState(null);
  const timer = useRef(null);

  const fail = useCallback((message) => {
    setError(message);
    clearTimeout(timer.current);
    timer.current = setTimeout(() => setError(null), 6000);
  }, []);
  useEffect(() => () => clearTimeout(timer.current), []);

  const attempt = useCallback(async (label, action) => {
    try {
      return await action();
    } catch (err) {
      fail(`${label} : ${err?.message || 'erreur inconnue'}`);
      throw err;
    }
  }, [fail]);

  return { error, fail, attempt };
};

export const errorText = (err) => err?.message || 'erreur inconnue';

export const ErrorText = ({ children, className = '' }) => (children
  ? <p className={`text-sm text-rose-600 ${className}`}>{children}</p>
  : null);
